import { AxiosResponse } from "axios";
import { SET_BUCKET_OPTIONS, SET_BUCKET_OPTION, SET_ERRORMSG } from "@/store/mutation-types";
import {
  CLEAR_BUCKET_OPTION_ISLOADING,
  DELETE_BUCKET_OPTION,
  EDIT_BUCKET_OPTION,
  GET_BUCKET_OPTIONS,
  REGISTER_BUCKET_OPTION,
} from "@/store/action-types";
import { StateObject } from "@/dtos/State.dto";
import BucketOption from "@/services/bucket/bucket-option";
import { Module } from "vuex";
import { EditBucketOption, RegisterBucketOption, GetBucketOption } from "@/dtos/BucketOption.dto";

const bucketOption: Module<any, {}> = {
  state: {
    bucketOption: {
      data: null,
      isLoading: false,
    },
    bucketOptions: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    bucketOption: (state: { bucketOption: any }) => state.bucketOption,
    bucketOptions: (state: { bucketOptions: any }) => state.bucketOptions,
  },
  mutations: {
    [SET_BUCKET_OPTION]: (
      state: { bucketOption: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.bucketOption.data = payload.data;
      state.bucketOption.isLoading = payload.isLoading;
    },
    [SET_BUCKET_OPTIONS]: (
      state: { bucketOptions: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.bucketOptions.data = payload.data;
      state.bucketOptions.isLoading = payload.isLoading;
    },
  },
  actions: {
    [REGISTER_BUCKET_OPTION]: async ({ commit }: any, payload: any) => {
      commit(SET_BUCKET_OPTION, { data: null, isLoading: true });

      try {
        const result: AxiosResponse = await BucketOption.registerBucketOption(
          payload as RegisterBucketOption
        );

        if (result) {
          if (result.data.status) {
            commit(SET_BUCKET_OPTION, {
              data: result.data.data,
              isLoading: false,
            });
            return true;
          }
          commit(SET_BUCKET_OPTION, { data: null, isLoading: false });
          commit(SET_ERRORMSG, result.data.msg);
          return false;
        } else {
          commit(SET_BUCKET_OPTION, { isLoading: false });
          return false;
        }
      } catch (error: any) {
        commit(SET_BUCKET_OPTION, { data: null, isLoading: false });

        // Handle timeout specifically
        if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
          commit(SET_ERRORMSG, "Request timed out. Please check your connection and try again.");
        } else {
          commit(SET_ERRORMSG, error.response?.data?.message || "Failed to register bucket option");
        }
        return false;
      }
    },
    [GET_BUCKET_OPTIONS]: async ({ commit }: any, payload: any) => {
      commit(SET_BUCKET_OPTIONS, { isLoading: true });

      try {
        const result: AxiosResponse = await BucketOption.getBucketOptions(
          payload as GetBucketOption
        );

        if (result) {
          if (result.data.status) {
            commit(SET_BUCKET_OPTIONS, {
              data: result.data.data,
              isLoading: false,
            });
            return true;
          }
          commit(SET_BUCKET_OPTIONS, { isLoading: false });
          commit(SET_ERRORMSG, result.data.msg);
          return false;
        } else {
          commit(SET_BUCKET_OPTIONS, { isLoading: false });
          return false;
        }
      } catch (error: any) {
        commit(SET_BUCKET_OPTIONS, { data: null, isLoading: false });

        // Handle timeout specifically
        if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
          commit(SET_ERRORMSG, "Request timed out. Please check your connection and try again.");
        } else {
          commit(SET_ERRORMSG, error.response?.data?.message || "Failed to load bucket options");
        }
        return false;
      }
    },
    [EDIT_BUCKET_OPTION]: async ({ commit }: any, payload: any) => {
      commit(SET_BUCKET_OPTION, { data: null, isLoading: true });

      try {
        const result: AxiosResponse = await BucketOption.editBucketOption(
          payload as EditBucketOption
        );

        if (result) {
          if (result.data.status) {
            commit(SET_BUCKET_OPTION, {
              data: result.data.data,
              isLoading: false,
            });
            return true;
          }
          commit(SET_BUCKET_OPTION, { data: null, isLoading: false });
          commit(SET_ERRORMSG, result.data.msg);
          return false;
        } else {
          commit(SET_BUCKET_OPTION, { isLoading: false });
          return false;
        }
      } catch (error: any) {
        commit(SET_BUCKET_OPTION, { data: null, isLoading: false });

        // Handle timeout specifically
        if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
          commit(SET_ERRORMSG, "Request timed out. Please check your connection and try again.");
        } else {
          commit(SET_ERRORMSG, error.response?.data?.message || "Failed to edit bucket option");
        }
        return false;
      }
    },
    [DELETE_BUCKET_OPTION]: async ({ commit }: any, payload: string) => {
      commit(SET_BUCKET_OPTION, { data: { id: payload }, isLoading: true });

      try {
        const result: AxiosResponse = await BucketOption.deleteBucketOption(payload);

        if (result) {
          if (result.data.status) {
            commit(SET_BUCKET_OPTION, {
              data: result.data.data,
              isLoading: false,
            });
            return true;
          }
          commit(SET_BUCKET_OPTION, { data: null, isLoading: false });
          commit(SET_ERRORMSG, result.data.msg);
          return false;
        } else {
          commit(SET_BUCKET_OPTION, { isLoading: false });
          return false;
        }
      } catch (error: any) {
        commit(SET_BUCKET_OPTION, { data: null, isLoading: false });

        // Handle timeout specifically
        if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
          commit(SET_ERRORMSG, "Request timed out. Please check your connection and try again.");
        } else {
          commit(SET_ERRORMSG, error.response?.data?.message || "Failed to delete bucket option");
        }
        return false;
      }
    },
    [CLEAR_BUCKET_OPTION_ISLOADING]: ({ commit }) => {
      commit(SET_BUCKET_OPTION, { isLoading: false });
      commit(SET_BUCKET_OPTIONS, { isLoading: false });
    },
  },
};

export default bucketOption;
